@if (cards$ | async; as cards) {
  <!-- <h3 class="cx-checkout-title d-none d-lg-block d-xl-block">
  {{ 'checkoutAddress.shippingAddress' | cxTranslate }}
</h3> -->
@if (!(isUpdating$ | async)) {
  @if (isAccountPayment || (cards?.length && !addressFormOpened)) {
    <!-- <p class="cx-checkout-text">
    {{ 'checkoutAddress.selectYourShippingAddress' | cxTranslate }}
  </p> -->
  <!-- <div class="cx-checkout-btns row" *ngIf="!isAccountPayment">
  <div class="col-sm-12 col-md-12 col-lg-6">
    <button class="btn btn-block btn-action" (click)="openAddressForm()">
      {{ 'checkoutAddress.addNewAddress' | cxTranslate }}
    </button>
  </div>
</div> -->
<div class="cx-checkout-body row pt-3">
  @if (deliveryAddress$ | async; as deliveryAddress) {
    @if (deliveryAddress?.isDisposable) {
      <div class="cx-shipping-address-card col-md-12 col-lg-6">
        <div class="cx-shipping-address-card-inner">
          <cx-card
            [border]="true"
            [fitToContainer]="true"
            [content]="getOtshAddress.card"
            (sendCard)="selectAddress(getOtshAddress.address)"
          ></cx-card>
        </div>
      </div>
    }
  }
  @for (card of cards | orderBy: 'card.header':'desc'; track card; let i = $index) {
    <div
      class="cx-shipping-address-card col-md-12 col-lg-6"
      >
      <div class="cx-shipping-address-card-inner" (click)="selectAddress(card.address)">
        <cx-card
          [border]="true"
          [fitToContainer]="true"
          [content]="card.card"
          (sendCard)="selectAddress(card.address)"
        ></cx-card>
      </div>
    </div>
  }
</div>
<div class="cx-checkout-btns row">
  <div class="col-md-12 col-lg-4 pl-0">
    <button class="cx-btn btn btn-block btn-action" (click)="back()">
      {{ backBtnText | cxTranslate }}
    </button>
  </div>
  <div class="col-md-12 col-lg-4">
    <button class="btn btn-block btn-action" (click)="openAddressForm()">
      {{ 'checkoutAddress.addNewAddress' | cxTranslate }}
    </button>
  </div>
  @if (selectedAddress$ | async; as selectedAddress) {
    <div class="col-md-12 col-lg-4 pr-0">
      <button class="cx-btn btn btn-block btn-primary" [disabled]="!selectedAddress?.id" (click)="next()">
        {{ 'common.continue' | cxTranslate }}
      </button>
    </div>
  }
</div>
} @else {
  @if (!isAccountPayment) {
    <div class="cx-checkout-btns row">
      <div class="col-sm-12 col-md-12 col-lg-6">
        <button class="btn btn-block btn-action" (click)="openAddressForm()">
          {{ 'checkoutAddress.addNewAddress' | cxTranslate }}
        </button>
      </div>
    </div>
  }
  <!-- <cx-address-form
  *ngIf="cards.length; else initialAddressForm"
  [showTitleCode]="true"
  (backToAddress)="hideNewAddressForm(false)"
  (submitAddress)="addAddress($event)"
></cx-address-form>
<ng-template #initialAddressForm>
  <cx-address-form
    [showTitleCode]="true"
    [setAsDefaultField]="!isGuestCheckout"
    [addressData]="selectedAddress"
    cancelBtnLabel="{{ backBtnText | cxTranslate }}"
    (backToAddress)="hideNewAddressForm(true)"
    (submitAddress)="addAddress($event)"
  ></cx-address-form>
</ng-template> -->
}
} @else {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
}
